/**
 * Joins class names, dropping anything falsy.
 *
 * Exists mainly because CSS module lookups are typed `string | undefined`
 * under `noUncheckedIndexedAccess`, so interpolating them into a template
 * literal is a type error — and silencing that with `String()` would hide
 * genuine typos in class names behind a literal "undefined" in the markup.
 */
export const cx = (...classes: (string | false | null | undefined)[]): string =>
  classes.filter(Boolean).join(' ');
